import { render, staticRenderFns } from "./imgEditor.vue?vue&type=template&id=f983b2a2&scoped=true&"
import script from "./imgEditor.vue?vue&type=script&lang=js&"
export * from "./imgEditor.vue?vue&type=script&lang=js&"
import style0 from "./imgEditor.vue?vue&type=style&index=0&id=f983b2a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f983b2a2",
  null
  
)

export default component.exports